import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-mess8",
  "use": "icon-mess8-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-mess8\"><path d=\"M588.8 64c-32-19.2-64-19.2-96 0L275.2 256H160C108.8 256 64 300.8 64 352v256c0 51.2 44.8 96 96 96h115.2l217.6 192c12.8 6.4 32 12.8 51.2 12.8 19.2 0 32-6.4 44.8-12.8 32-19.2 51.2-51.2 51.2-83.2V147.2c0-38.4-19.2-70.4-51.2-83.2zM128 608v-256c0-19.2 12.8-32 32-32H256v320H160c-19.2 0-32-12.8-32-32z m448 204.8c0 19.2-12.8 25.6-19.2 25.6-6.4 0-19.2 6.4-25.6 0L320 659.2V300.8l211.2-185.6c12.8-6.4 25.6 0 32 0 0 6.4 12.8 12.8 12.8 32v665.6zM800 256c6.4 0 19.2 0 25.6-6.4l128-128c12.8-12.8 12.8-32 0-44.8s-32-12.8-44.8 0l-128 128c-12.8 12.8-12.8 32 0 44.8 0 6.4 12.8 6.4 19.2 6.4z m192 192h-192c-19.2 0-32 12.8-32 32s12.8 32 32 32h192c19.2 0 32-12.8 32-32s-12.8-32-32-32z m-166.4 262.4c-12.8-12.8-32-12.8-44.8 0s-12.8 32 0 44.8l128 128c6.4 6.4 12.8 6.4 25.6 6.4s19.2 0 25.6-6.4c12.8-12.8 12.8-32 0-44.8l-134.4-128z\" fill=\"\" p-id=\"6170\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-mess8.svg
// module id = PdYl
// module chunks = 177